/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
/* eslint-env browser */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Image } from 'chakra-v3';
import { withBaseUrl } from '../../utils/url';

/**
 * MinimalHeader component.
 *
 * Displays only the centered logo.
 * Intended for use on layouts like Login, 404, or specific landing pages
 * where navigation should be restricted.
 */
const MinimalHeader: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      as="nav"
      bg="bg.primary"
      px={{ base: '16px', md: '32px', lg: '48px' }}
      py={{ base: '12px', md: '20px', lg: '24px' }}
      position="sticky"
      top={0}
      zIndex={1000}
    >
      <Flex align="center" justify="center" w="100%" maxW="1920px" mx="auto">
        {/* Logo */}
        <Flex
          as="button"
          cursor="pointer"
          onClick={() => void navigate('/')}
          _hover={{ opacity: 0.9 }}
          _active={{ opacity: 0.8 }}
          transition="opacity 0.2s ease"
          alignItems="center"
          bg="transparent"
          border="none"
          p={0}
          gap={{ base: '6px', md: '8px' }}
          flexShrink={0}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            w="120px"
            h="36.219px"
            flexShrink={0}
            position="relative"
            overflow="hidden"
          >
            <Image
              src={withBaseUrl('/karya_evals_logo.svg')}
              alt="Karya Evals Logo"
              w="100%"
              h="100%"
              objectFit="contain"
              position="absolute"
              inset={0}
            />
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

export default MinimalHeader;
